import React from "react";
import { useNavigate } from "react-router-dom";
import FormAddGiftExchangeTable from "./FormAddGiftExchangeTable";

export default function AddGiftExchangePage() {
  const navigate = useNavigate();
  const back = () => navigate("/gift-exchanges");

  return (
    <FormAddGiftExchangeTable
      asPage
      isModalOpen={true}
      currentPage={1}
      pageSize={10}
      handleOk={back}
      handleCancel={back}
    />
  );
}
